import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import TasteProfileIcon, { icons, iconNames } from '../TasteProfileIcon'

import { preloadImages } from 'utils/preload'
import { RED_LABEL, WHITE_LABEL } from 'constants/wines'

import styles from './TasteProfileCarousel.css'

class TasteProfileCarousel extends Component {
  constructor () {
    super()
    const numberOfIcons = iconNames.length
    this.state = {
      currentIconIndex: Math.floor(Math.random() * numberOfIcons),
      targetRedIndex: null,
      targetWhiteIndex: null
    }
    this.interval = undefined
    this.done = false

    this.handleNextIcon = this.handleNextIcon.bind(this)
    this.startInterval = this.startInterval.bind(this)
  }

  componentWillMount () {
    this.preloadStartImages()
  }

  componentWillReceiveProps ({ result, animationMinTimeCompleted }) {
    let white
    let red
    try {
      white = result[WHITE_LABEL].className
      red = result[RED_LABEL].className
    } catch (error) {
      white = 'bigWhite'
      red = 'bigRed'
    }
    const targetWhiteIndex = iconNames.indexOf(white)
    const targetRedIndex = iconNames.indexOf(red)

    if (animationMinTimeCompleted) {
      this.stopInterval()
    }
    this.preloadImagesAtIndex([targetRedIndex, targetWhiteIndex], () => this.setState({
      targetWhiteIndex,
      targetRedIndex
    }))
  }

  componentWillUnmount () {
    this.done = true
    this.stopInterval()
  }

  renderIconTransition (icon, position = 'center') {
    const { onAnimationComplete, animationMinTimeCompleted } = this.props
    const { targetWhiteIndex, targetRedIndex } = this.state
    const transitionGroupProps = {
      key: `${iconNames[icon]}-${position}-${icon}`,
      classNames: {
        enter: styles[`slide-${position}-enter`],
        enterActive: styles[`slide-${position}-enter-active`],
        exit: styles[`slide-${position}-exit`],
        exitActive: styles[`slide-${position}-exit-active`]
      },
      timeout: this.props.fadeDuration
    }

    if (onAnimationComplete && ['left', 'right'].indexOf(position) !== -1) {
      transitionGroupProps.timeout = 500
    }
    if (onAnimationComplete && targetWhiteIndex !== null && targetRedIndex !== null && animationMinTimeCompleted) {
      transitionGroupProps.onEntered = () => onAnimationComplete()
    }

    return (
      <CSSTransition {...transitionGroupProps}>
        <div className={classnames(styles.icon, styles[`icon-${position}`])}>
          <TasteProfileIcon profile={iconNames[icon]} width={0} />
        </div>
      </CSSTransition>
    )
  }

  renderDone () {
    const { targetWhiteIndex, targetRedIndex } = this.state
    return [
      this.renderIconTransition(targetRedIndex, 'left'),
      this.renderIconTransition(targetWhiteIndex, 'right')
    ]
  }

  renderContent () {
    const { currentIconIndex } = this.state
    return this.renderIconTransition(currentIconIndex, 'center')
  }

  render () {
    const { animationMinTimeCompleted } = this.props
    const { targetRedIndex, targetWhiteIndex } = this.state
    return (
      <TransitionGroup
        key={'transition'}
        className={classnames(this.props.className, styles.container)}
      >
        {(animationMinTimeCompleted && targetRedIndex !== null && targetWhiteIndex !== null)
          ? this.renderDone()
          : this.renderContent()
        }
      </TransitionGroup>
    )
  }

  preloadStartImages () {
    const { currentIconIndex } = this.state
    const { interval, animationMinTime } = this.props
    const numberOfIcons = iconNames.length

    const imageIndexesToPreload = [currentIconIndex]
    for (let i = 0, limit = Math.floor(animationMinTime / interval); i < limit - 1; i += 1) {
      imageIndexesToPreload.push((currentIconIndex + 1 + i) % numberOfIcons)
    }
    this.preloadImagesAtIndex(imageIndexesToPreload, this.startInterval)
  }

  preloadImagesAtIndex (indexes, callback) {
    const urls = []
    indexes.forEach((index) => {
      urls.push(icons[iconNames[index]])
    })
    preloadImages(urls, callback)
  }

  startInterval () {
    if (this.done) {
      return null
    }
    const { interval } = this.props
    this.interval = setInterval(this.handleNextIcon, interval)
  }

  stopInterval () {
    clearInterval(this.interval)
  }

  handleNextIcon () {
    const { currentIconIndex } = this.state
    const nextIndex = (currentIconIndex + 1) % iconNames.length

    this.setState({
      currentIconIndex: nextIndex
    })
  }
}

TasteProfileCarousel.defaultProps = {
  className: undefined,
  interval: 1000,
  fadeDuration: 200,
  animationMinTime: 3000,
  animationMinTimeCompleted: false,
  onAnimationComplete: () => {}
}

TasteProfileCarousel.propTypes = {
  className: PropTypes.string,
  interval: PropTypes.number,
  animationMinTime: PropTypes.number,
  fadeDuration: PropTypes.number,
  animationMinTimeCompleted: PropTypes.bool,
  onAnimationComplete: PropTypes.func,
  result: PropTypes.object
}

export default TasteProfileCarousel
